import React, {useEffect, useState} from 'react'
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import Header from "../../../layout/header";
import ReactPaginate from "react-paginate";
import NotFoundData from "../../../../Images/no-data-found.webp";
import Moment from "moment";
import BottomMenu from "../../../layout/bottomMenu";
import {addressApprovalPendingListRequest} from "../../../../service/Lead/action";
const LeadAddressPendingList = ({
                                    addressApprovalPendingListResponse,
                                    addressApprovalPendingListRequest,
                            history
                        }) => {

    const [isLoading, setIsLoading] = useState(false)
    const [searchValue, setSearchValue] = useState('')
    const [filterInputList, setFilterInputList] = useState([{}])
    const [open, setOpen] = useState(false);
    const [isFilterRemove, setIsRemoveFilter] = useState(false)
    const [pageNo, setPage] = useState(1)

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            let filter = window.localStorage.address_approval_pending_list ? JSON.parse(window.localStorage.address_approval_pending_list) : [];
            if(filter.length > 0 && filter[0]['status']){
                await addressApprovalPendingListRequest('Dealer', pageNo, '', filter[0]['status'])
            } else  {
                await addressApprovalPendingListRequest('Dealer')
            }
            setIsLoading(false)
        })()
    }, [])


    const onPageChange = async (val) => {
        setIsLoading(true)
        setPage(val?.selected+1)
        let filter = window.localStorage.address_approval_pending_list ? JSON.parse(window.localStorage.address_approval_pending_list) : [];
        if(filter.length > 0 && filter[0]['status']){
            await addressApprovalPendingListRequest('Dealer', val?.selected+1, '', filter[0]['status'])
        } else {
            await addressApprovalPendingListRequest('Dealer', val?.selected+1)
        }
        setIsLoading(false)
    };



    const handleSearch = async () => {
        if (searchValue === '') {
            return false
        }
        if(searchValue){
            await addressApprovalPendingListRequest('Dealer', 1, searchValue)
        }

    }

    const removeSearchFilter = async () => {
        delete window.localStorage.search_lead
        setIsLoading(true)
        await addressApprovalPendingListRequest('Dealer')
        setIsLoading(false)
    }

    const handleSubmitFilter = async () => {
        setOpen(false)
        setIsLoading(true)
        window.localStorage.address_approval_pending_list = JSON.stringify(filterInputList)
        if(filterInputList[0] && filterInputList[0]['status']) {
            await addressApprovalPendingListRequest('Dealer', pageNo, '', filterInputList[0]['status'])
        }
        setIsLoading(false)
    }

    const handleRemoveFilter = async (key) => {
        if(key !== ''){
            delete filterInputList[0][key]
            setFilterInputList(filterInputList)
            setIsLoading(true)
            await addressApprovalPendingListRequest('Dealer', pageNo, '', filterInputList)
            setIsLoading(false)
        }
    }

    useEffect(() => {
        (async () => {
            if (isFilterRemove) {
                setFilterInputList([{}])
                setIsLoading(true)
                await addressApprovalPendingListRequest('Dealer', pageNo, '')
                setIsLoading(false)
                setIsRemoveFilter(false)
            }
        })()
    }, [isFilterRemove])

    const  handleApprove = async () => {
        setIsLoading(true)
        await addressApprovalPendingListRequest('Dealer', pageNo, '', 2)
        setIsLoading(false)
    }

    const handleFilter = async (key, value, stringValue = '') => {
        const list = [...filterInputList]
        list[0][key] = value
        setFilterInputList(list)
    }

    return (
        <>
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={'Lead Address List'}
                            history={history}
                        />
                        <div className="container-fluid common-bg">
                            {/*Heading*/}
                            <div className="container-fluid bootstrap snippets bg-white">
                                <div className="d-sm-flex align-items-center justify-content-between ">
                                    <div className="row col-md-12">
                                        <div className="col-md-6 col-sm-6 d-flex mt-20px ">
                                            <form className="form-inline mr-auto w-90 navbar-search">
                                                <div className="d-flex w-100">
                                                    <input type="text"
                                                           className="form-control bg-light border-0 small list-filter"
                                                           placeholder="Search Lead..." aria-label="Search"
                                                           aria-describedby="basic-addon2"
                                                           onChange={(e) => {
                                                               setSearchValue(e.target.value)
                                                           }}
                                                    />
                                                    <div className="remove-search-filter">
                                                        <i className="fa fa-times" aria-hidden="true"
                                                           onClick={removeSearchFilter}></i>
                                                    </div>
                                                    <div className="btn-search">
                                                        <button className="btn btn-primary lh-32 border-left-tr-tb"
                                                                type="button"
                                                                onClick={(e) => handleSearch()}
                                                        >
                                                            <i className="fas fa-search fa-sm"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                        <div className="col-md-6 cs-pos">
                                            <button onClick={() => setOpen(!open)}
                                                    className="btn btn-sm btn-primary mr-1 btn-filter"
                                                    type="button"><i
                                                className="fa fa-filter lh-35 pd-3"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {filterInputList[0] !== undefined && Object.keys(filterInputList[0]).length > 0 &&
                                    <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                        <div className="row pd-filter-div">
                                            <div className="col-md-12 col-sm-12 d-flex">
                                                <div className="applied-filter">
                                                    {Object.keys(filterInputList[0]).map((val, i) => {
                                                        return (
                                                            <>
                                                            <span className="fd-1">
                                                                <span style={{textTransform:"capitalize"}}>
                                                                    {val.replaceAll("_", " ")}
                                                                </span>
                                                                {val === 'status' ? parseInt(filterInputList[0][val]) === 1 ? " - Pending" : parseInt(filterInputList[0][val]) === 2 ? " - Approved" : "  - Rejected" : " - "+filterInputList[0][val] }
                                                                <i className="bi bi-x-circle" onClick={(e) => {handleRemoveFilter(val)}}></i></span>
                                                            </>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className="row">
                                    {/*CARD START*/}
                                    {addressApprovalPendingListResponse && addressApprovalPendingListResponse?.data !== undefined && addressApprovalPendingListResponse?.data !== [] && addressApprovalPendingListResponse?.data.map((val, i) => {
                                        return (
                                            <>
                                                <div className="col-md-4 col-sm-6">
                                                    <div className="card-big-shadow">
                                                        <div className="card card-just-text" data-background=""
                                                             data-color=""
                                                             data-radius="none">
                                                            <div className="content">
                                                                <h6 className="category mrg-b-12">
                                                                    <div className="row">
                                                                        <div className="col-10" style={{
                                                                            color: "#000",
                                                                            fontSize: "20px",
                                                                            textAlign: "left",
                                                                            paddingLeft: "20px"
                                                                        }}>
                                                                            <div className="d-flex">
                                                                                {`${val?.account_name}`}
                                                                            </div>

                                                                        </div>
                                                                    </div>


                                                                    <div className="row list-view">
                                                                        {val?.meta_data && Object.keys(val?.meta_data).length > 0 &&
                                                                            <>
                                                                                {val?.master_dealer_type !== null &&
                                                                                    <div className="mb-flex">
                                                                                        <div
                                                                                            className="col-md-6 col-sm-6 no-wrap">
                                                                                            <i className="fa fa-industry"
                                                                                               aria-hidden="true"></i>&nbsp;&nbsp;Dealer
                                                                                            Name
                                                                                        </div>
                                                                                        <div
                                                                                            className="col-md-6 col-sm-6 l2">
                                                                                    <span className="trigger"
                                                                                          data-tooltip-id="1"
                                                                                          title={val?.meta_data[0]?.master_dealer_type}>{val?.meta_data[0]?.master_dealer_type}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                }
                                                                            </>
                                                                        }

                                                                        {val?.created_name &&
                                                                            <div className="mb-flex">
                                                                                <div
                                                                                    className="col-md-6 col-sm-6 no-wrap">
                                                                                    <i className="fa fa-user"></i>&nbsp;&nbsp;Requestor
                                                                                    Email
                                                                                </div>
                                                                                <div
                                                                                    className="col-md-6 col-sm-6">{val?.created_name}</div>
                                                                            </div>
                                                                        }

                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="fas fa-calendar-alt"></i>&nbsp;&nbsp;Requestor
                                                                                Date
                                                                            </div>
                                                                            <div
                                                                                className="col-md-6 col-sm-6">{Moment(val?.created_at).format('DD-MM-YYYY')}</div>
                                                                        </div>
                                                                    </div>
                                                                    <hr/>
                                                                    {parseInt(val?.status) === 1 &&
                                                                        <div className="row list-view-links">
                                                                            <ul>
                                                                                <li></li>
                                                                                <li>
                                                                                    <a
                                                                                        href={`dsm-lead-address-approval/${val?.id}`}>
                                                                                        <i className="fa fa-tasks"
                                                                                           aria-hidden="true"></i>&nbsp;&nbsp;Action</a>
                                                                                </li>

                                                                            </ul>
                                                                        </div>
                                                                    }

                                                                    {parseInt(val?.status) === 2 &&
                                                                        <div className="row list-view-links">
                                                                            <ul>
                                                                                <li></li>
                                                                                <li>
                                                                                    <a
                                                                                        href={`dsm-lead-address-approval/${val?.id}`}>
                                                                                        <i className="fa fa-tasks"
                                                                                           aria-hidden="true"></i>&nbsp;&nbsp;View</a>
                                                                                </li>

                                                                            </ul>
                                                                        </div>
                                                                    }
                                                                </h6>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    })}
                                    {addressApprovalPendingListResponse && addressApprovalPendingListResponse?.data !== undefined && addressApprovalPendingListResponse?.data.length > 0 &&
                                        <div className="panel-pagination-col panel-table-pagination">
                                            <ReactPaginate
                                                previousLabel={'<'}
                                                nextLabel={'>'}
                                                breakLabel={'...'}
                                                breakClassName={'break-me'}
                                                pageCount={(addressApprovalPendingListResponse?.total / addressApprovalPendingListResponse?.per_page)}
                                                forcePage={addressApprovalPendingListResponse?.current_page - 1}
                                                pageRangeDisplayed={4}
                                                onPageChange={onPageChange}
                                                activeClassName={'active'}
                                            />
                                        </div>
                                    }
                                    {addressApprovalPendingListResponse && addressApprovalPendingListResponse?.data !== undefined && addressApprovalPendingListResponse?.data.length === 0 &&
                                        <>
                                            <img src={NotFoundData} className="not-found-data" alt={""}/>
                                            <div className="text-center" style={{"width": "100%"}}>
                                                Data Not Found
                                            </div>
                                        </>
                                    }
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <BottomMenu
                    open={open}
                    setOpen={setOpen}
                    handleSubmitFilter={handleSubmitFilter}
                    filterContent={{
                        data: [{
                            field: 'dropdown',
                            place_holder: 'Status',
                            values: [{id: 2, name: "Approved"}, {id: 3, name: "Rejected"}]
                        }]
                    }}
                    handleFilter={handleFilter}
                    setIsRemoveFilter={setIsRemoveFilter}
                    localstorageKeyRemove={'address_approval_pending_list'}
                />
            </div>
            {/* section ends */}
        </>
    )
}

export default LeadAddressPendingList